import { render, staticRenderFns } from "./RoLogin.vue?vue&type=template&id=14822721&scoped=true&"
import script from "./RoLogin.vue?vue&type=script&lang=js&"
export * from "./RoLogin.vue?vue&type=script&lang=js&"
import style0 from "./RoLogin.vue?vue&type=style&index=0&id=14822721&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14822721",
  null
  
)

export default component.exports